<div class="app-select" [ngClass]="[size, customClass]">
  <select
    [ngModel]="value"
    (ngModelChange)="onChange($event)">

    <!-- Placeholder -->
    <option
      [ngValue]="null"
      disabled
      hidden>
      {{ placeholder }}
    </option>

    <!-- Opciones -->
    <option
      *ngFor="let opt of options"
      [ngValue]="valueKey ? opt[valueKey] : opt">

      <ng-container *ngIf="showCode && codeKey; else onlyLabel">
        {{ opt[codeKey] }} - {{ opt[labelKey] }}
      </ng-container>

      <ng-template #onlyLabel>
        {{ opt[labelKey] }}
      </ng-template>

    </option>
  </select>
</div>
